import type { ReactNode } from 'react';

export const symbol_coffee: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M442-242q-116 0-199-80.04-83-80.05-83-194.96v-263q0-24.75 17.63-42.38Q195.25-840 220-840h529q54.27 0 92.64 37Q880-766 880-712q0 60-37 106t-94 46h-25v43q0 114.91-83 194.96Q558-242 442-242ZM220-620h444v-160H220v160Zm222 318q91 0 156.5-62T664-517v-43H220v43q0 91 65.5 153T442-302Zm282-318h25q33 0 52-28.5t19-63.5q0-29-21-48.5T749-780h-25v160ZM190-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h580q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H190Zm252-440Z"
		/>
	</svg>
);
